module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('share-buttons', {
    ref: "shareButtons",
    staticClass: "related-person-overlay-sharebar",
    class: [{
      active: _vm.mode === 'collapse',
      hide: _vm.mode !== 'collapse'
    }, ("theme-" + _vm.theme)],
    attrs: {
      "mode": _vm.sharebarMode,
      "url": _vm.shareData.url,
      "shortenUrl": _vm.shareData.shortenUrl,
      "title": _vm.shareData.title,
      "gtmType": this.theme === 'desktop' ? 'gtmType_shareBtn-default' : 'gtmType_shareBtn-adhesiveBar'
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5311e48e","hasScoped":true,"preserveWhitespace":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./components/node/person/ShareBar.vue
// module id = 1751
// module chunks = 1